import {OrderDto, SectionFragmentDto, SectionFragmentType} from "@hec/api-dtos";
import {getSouthFaceFromOrder} from "./GetSouthFaceFromOrder";
import {getSectionFragmentsFromOrder} from "./GetSectionFragmentsFromOrder";


export const getSectionFragmentsFromOrderByType = (order: OrderDto, sectionFragmentType: SectionFragmentType): SectionFragmentDto[] => {
  const sectionFragments = getSectionFragmentsFromOrder(order)
  const result = sectionFragments
    .filter((sectionFragment) => sectionFragment.sectionFragmentType === sectionFragmentType)
    .sort((prev, next) => prev.sort! - next.sort!);
  return (result as SectionFragmentDto[]);
}

import { createSelector } from '@reduxjs/toolkit';
import {DormerRootState} from "../../DormerRootState";
export const makeGetSectionFragmentsFromOrderByType = (sectionFragmentType: SectionFragmentType) =>
  createSelector(
    [(state: DormerRootState) => state.order],
    (orderState) => {
      if(!orderState.order) {
        return []
      }
      const sectionFragments = getSectionFragmentsFromOrder(orderState.order);
      return sectionFragments
        .filter((sectionFragment) => sectionFragment.sectionFragmentType === sectionFragmentType)
        .sort((a, b) => (a.sort ?? 0) - (b.sort ?? 0)) as SectionFragmentDto[];
    }
  );

